// Reskin JavaScript Pack
// This pack is loaded exclusively on reskin pages (via layouts/reskin/base.html.haml)
// It includes reskin-specific JavaScript; the Fragno design system itself
// loads from one of the fragno_latest/fragno_next packs (ApplicationController#fragno_pack)

// TEMPORARY workaround for a fragno defect (t-fragno-component-fixes.3) --
// see the module for detail. Must run after the fragno pack loads so the
// custom element is already registered/upgraded.
import "../modules/fragno_page_header_role_fix";

// Analytics — modern replacement for IDmeEvent.js on reskin pages.
import { loadAnalytics } from "../modules/analytics_loader";
loadAnalytics(window.settings);

// Interstitial page behavior (redirect, sign-in + clipboard)
import "../interstitial";
// v2 code interstitial: redirect after fragno-interstitial-lockup's built-in
// coupon-copy button fires its copy event
import "../modules/interstitial_lockup_copy";

// Native web components for reskin pages
import "../web-components/native_components/shop_community_selector";
import "../web-components/native_components/shop_mobile_menu";
import "../web-components/native_components/shop_profile_dropdown";
import "../web-components/native_components/shop_local_nav";
import "../web-components/native_components/shop_search_bar";
import "../web-components/native_components/split_banner";
import "../web-components/native_components/shop_collapsible";
import "../web-components/native_components/shop_community_card";
import "../web-components/native_components/shop_show_more";
import "../web-components/native_components/shop_infinite_offers";
import "../web-components/native_components/shop_favorite_button";
import "../web-components/native_components/shop_search_dropdown";

// My Cash page modules
import "../modules/my_cash_history_selector";
import "../modules/my_cash_load_more";
import "../modules/my_cash_store_autocomplete";
import "../modules/my_cash_missing_form";
import "../modules/my_cash_paypal_form";

// Nav wiring — connects fragno-global-nav events to shop components
import "../modules/shop_nav_wiring";

// Nav v2 wiring: feeds search to fragno-global-nav-v2
import "../modules/shop_nav_v2_wiring";

// Browser extension install modal
import "../modules/browser_extension_modal";

// Scoped hash-open handler for opt-in modals (e.g. #store-restrictions)
import "../modules/store_modal_hash";

// Reveals the restrictions "Read more" trigger only when its clamped
// excerpt is actually overflowing (ResizeObserver, not a character count)
import "../modules/restrictions_overflow";

// SG-949 / SG-945 Member Assistant chat widget
// Legacy sprockets version (shopAssistant.coffee) never loads on reskin
// because reskin doesn't include application.js. This is the port.
import "../modules/shop_assistant";

// SG-1394: tags post-search links with the search id (port of searchIdAppender.js)
import "../modules/search_attribution";

// Marks the neighbors a peeking carousel shows beside its active slide; the v2
// hero section's CSS dims them
import "../modules/hero_carousel_peek";

// Brand FAQ feedback form
import "../modules/brand_feedback";
// Extension page reskin reviews carousel
import "../modules/extension_reviews_carousel";
// Member advocacy interstitial (clipboard + frustration-hint reveal)
import "../modules/advocacy_campaign";
// Re-apply popular-offers anchor scroll after layout settles.
// Explicit entrypoint call (not a side-effect import) so the module stays
// pure — importing it elsewhere won't trigger a real scroll attempt.
import { initPopularOffersAnchorScroll } from "../modules/popular_offers_anchor_scroll";

initPopularOffersAnchorScroll();
